<template>
  <div>
    <div class="title">学生账号注册</div>
    <div>
      <p class="tips" style="color: red;">注意：</p>
      <p class="tips" style="color: red;width: 550px">1. 每个账号只能1个用户使用，注册时请准确填写考生姓名、电话、高考年份、高考选科等信息，完成注册后关键个人信息将不可更改；</p>
			<p class="tips" style="color: red;width: 550px">2. 系统在6-8月不对非高三考生开放“院校查询”“定位专业”“方案设计”等模块功能；</p>
			<p class="tips" style="color: red;width: 550px">3. 未分科考生购卡后，须在本页预填选考科目，在进入高三前可更改高考选科，进入高三后高考选科会被锁定。</p>
    </div>
    <el-form class="modify-form" ref="registersForm" :model="form" :rules="rules" size="medium" label-width="135px">
      <el-form-item label="智能卡号：" prop="cardCode">
        <el-input v-model="form.cardCode" @blur="getUserLevel" placeholder="非必填项, 无卡用户可忽略" style="width: 244px;" clearable></el-input>
      </el-form-item>
      <el-form-item label="身份类别：" prop="userLevel">
        <el-input v-model="signUserLevel" style="width: 244px;" clearable readonly></el-input>
      </el-form-item>
      <el-form-item label="初始密码：" prop="codepwd">
        <el-input v-model="form.codepwd" placeholder="注册完成后可用于密码登录" style="width: 244px;" clearable></el-input>
      </el-form-item>
      <el-form-item label="考生姓名：" prop="nickName">
        <el-input v-model="form.nickName" style="width: 244px;" clearable></el-input>
      </el-form-item>
      <el-form-item label="就读学校：" prop="school">
        <el-input v-model="form.school" style="width: 244px;" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="科类：" prop="majorType">
        <el-select v-model="form.majorType" style="width: 244px;" placeholder="请选择">
          <el-option label="文科" :value="2"></el-option>
          <el-option label="理科" :value="1"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="首选科目(2选1)：" prop="majorType">
        <el-radio-group v-model="form.majorType">
          <el-radio label="1">物理</el-radio>
          <el-radio label="2">历史</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="再选科目(4选2)：" prop="subject">
        <el-checkbox-group v-model="form.subject" :max="2">
          <el-checkbox v-for="item in secondarilySubjects" :label="item.value" :key="item.value">
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="高考年份：" prop="year">
        <el-date-picker v-model="form.year" value-format="yyyy" type="year" style="width: 244px;" placeholder="选择年">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="手机号：" prop="phone">
        <el-input v-model="form.phone" style="width: 244px;" clearable></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="code">
        <el-input v-model="form.code" style="width: 244px;" clearable></el-input>
        <el-button v-show="!countDown" style="color: var(--primaryColor);border: none;" @click="getSMSCodeByPhone">
          获取验证码
        </el-button>
        <el-button v-show="countDown" style="color: var(--primaryColor);border: none;">
          {{ countDown }}s
        </el-button>
      </el-form-item>
      <el-form-item label="登录密码：" prop="password">
        <el-input v-model="form.password" placeholder="请设置登录密码" style="width: 244px;" clearable></el-input>
      </el-form-item>
      <el-form-item label="确认登录密码：" prop="checkPassword">
        <el-input v-model="form.checkPassword" placeholder="请确认登录密码" style="width: 244px;" clearable></el-input>
      </el-form-item>
      <el-form-item prop="isConsentAgreement">
        <el-checkbox v-model="form.isConsentAgreement">我已阅读并同意</el-checkbox>
        <span @click="$refs.privacyDialog.open()" style="color: var(--primaryColor); cursor: pointer;">《用户协议和免责说明》</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :submitLoading="submitLoading" @click="validateForm()" class="modify-button">
          注册
        </el-button>
        <el-button type="primary" @click="gologin()" class="modify-button">
          去登录
        </el-button>
      </el-form-item>
    </el-form>
    <Privacy @confirm="form.isConsentAgreement = true" ref="privacyDialog" />
  </div>
</template>
<script>
import { request } from "@/util/request.js"
import Privacy from "@/components/Privacy"
export default {
  inheritAttrs: false,
  components: { Privacy },
  props: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.checkPassword !== '') {
          this.$refs['registersForm'].validateField('checkPassword');
        }
        callback();
      }
    };
    var validateCheckPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      countDown: '', // 验证码倒计时
      secondarilySubjects: this.$constants.secondarilySubjects,
      form: {
        id: undefined,
        nickName: undefined,
        cardCode: undefined,
        codepwd: undefined,
        school: undefined,
        majorType: undefined,
        year: undefined,
        phone: undefined,
        openid: undefined,
        subject: [],
        isConsentAgreement: false,
      },
      submitLoading: false,
      rules: {
        cardCode: [
          { required: true, message: '请输入智能卡号！', trigger: 'change' },
        ],
        codepwd: [
          { required: true, message: '请输入初始密码！', trigger: 'change' },
        ],
        nickName: [
          { required: true, message: '请输入姓名！', trigger: 'change' },
        ],
        school: [
          { required: true, message: '请输入就读学校名称！', trigger: 'change' },
        ],
        majorType: [
          { required: true, message: '请选择首选科目', trigger: 'change' },
        ],
        subject: [
          { required: true, message: '请选择再选科目(4选2)', trigger: 'change' },
        ],
        year: [
          { required: true, message: '请选择高考年份！', trigger: 'change' },
        ],
        phone: [
          { required: true, message: '请输入手机号码！', trigger: 'change' },
        ],
        code: [
          { required: true, message: '请输入验证码！', trigger: 'change' },
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'change', },
        ],
        checkPassword: [
          // { required: true, message: '请再次输入密码', trigger: 'change' },
          { required: true, validator: validateCheckPassword, trigger: 'change' },
        ],
        isConsentAgreement: [
          {
            validator: function validateAccept(rule, value, callback) {
              value ? callback() : callback(new Error())
            },
            message: '请您阅读并同意《用户协议和免责声明》',
            trigger: 'change'
          },
        ],
      },
      signUserLevel: "",
    }
  },
  computed: {},
  watch: {},
  created() {
    let date = new Date()
    let nowMonth = date.getMonth() + 1
    // 进入9月1号默认选中下一年
    if (nowMonth >= 9) {
      this.form.year = date.getFullYear() + 1 + ''
    }
  },
  mounted() {

  },
  methods: {
    getSMSCodeByPhone() {
      this.$refs['registersForm'].validateField('phone', (errorMessage) => {
        if (errorMessage) {
          return this.$message.error(errorMessage);
        }
        const TIME_COUNT = 60
        request({
          method: 'POST',
          url: 'sysUser/syan',
          params: {
            phone: this.form.phone
          }
        }).then(res => {
          if (![null, 0].includes(res.code)) {
            return this.$message.error(res.msg);
          }
          if (!this.timers) {
            this.countDown = TIME_COUNT;
            this.timers = setInterval(() => {
              if (this.countDown > 0 && this.countDown <= TIME_COUNT) {
                this.countDown--;
              } else {
                clearInterval(this.timers);
                this.timers = null;
              }
            }, 1000)
          }
          this.$message.success(res.msg);
        })
      })
    },

    validateForm() {
      this.$refs['registersForm'].validate(valid => {
        if (!valid) return

        if (this.form.subject.length < 2) {
          return this.$message.error('再选科目最少选择2个')
        }

        this.$confirm(`注册后信息将不可更改，您确定信息无误并提交？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => this.submitForm())
      })
    },
    submitForm() {
      this.submitLoading = true
      let [subject1, subject2] = this.form.subject
      request({
        method: 'POST',
        url: 'sysUser/register',
        data: {
          ...this.form,
          subject: undefined,
          subject1, subject2
        },
        params: {
          code: this.form.code,         // 验证码
          codepwd: this.form.codepwd    // 初始密码
        }
      }).then(res => {
        if (![0, 200].includes(res.code)) {
          return this.$message.error(res.msg)
        }else{
          this.$message.success(res.msg);
          this.timer = setTimeout(()=>{   //设置延迟执行
            this.$parent.showRegisters = false
          },500);
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },

    gologin() {
      this.$parent.showRegisters = false
    },
    getUserLevel(){
      request({
        method: 'get',
        url: 'sysUser/getUserLevel',
        params: {
          cardCode: this.form.cardCode
        }
      }).then(res => {
        setTimeout(() => {
          this.signUserLevel = res.data;
        }, 10);
      });
    }
  }
}

</script>
<style lang="stylus" scoped>
@import './common.styl'

.tips
  font-size: 15px;
  margin 15px 0
.modify-button
  width: 120px

// .modify-form /deep/
//   .el-input__inner
//     width 244px

</style>
